<template>
  <div class="face" id="face">
    <img
      ref="face"
      :src="faceIcon || require('../../../../assets/images/chat/face.png')"
      alt=""
      @click="toggleShow"
    />
    <main
      class="face-main"
      :class="[isH5 && 'face-H5-main']"
      v-show="showDialog"
      ref="dialog"
    >
      <ul class="face-list">
        <li v-for="(item, key) in emojiList" :key="key">
          <img
            :src="item.url"
            @mouseover="onMouseover(item)"
            @mouseout="onMouseout(item)"
            alt=""
            @click="select(item)"
          />
        </li>
      </ul>
    </main>
  </div>
</template>

<script>
import {
  emojiUrl,
  emojiMap,
  emojiPngMap,
  emojiPngUrl,
  emojiName,
} from "@saas/components/src/utils/im/emoji-map";
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    isMute: {
      type: Boolean,
      default: () => false,
    },
    isH5: {
      type: Boolean,
      default: () => false,
    },
    parentID: {
      type: String,
      default: () => "",
    },
    faceIcon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      emojiMap,
      emojiName,
      emojiUrl,
      emojiPngMap,
      emojiPngUrl,
      currentIndex: 0,
      transDom: false,
      showDialog: false,
      emojiList: [],
    };
  },
  computed: {},
  mounted() {
    this.emojiList = this.emojiName.map((item) => {
      const pngUrl = this.emojiPngUrl + this.emojiPngMap[item];
      const gifUrl = this.emojiUrl + this.emojiMap[item];
      return {
        name: item,
        url: pngUrl,
        pngUrl: pngUrl,
        gifUrl: gifUrl,
      };
    });
    document.addEventListener("click", this.handleClickOutside);
  },
  methods: {
    // 点击其他地方隐藏
    handleClickOutside(e) {
      if (e.target !== this.$refs.face) {
        this.showDialog = false;
      }
    },
    toggleShow() {
      if (this.isMute) {
        return;
      }
      this.showDialog = !this.showDialog;
    },
    select(face) {
      this.$emit("select", face);
    },
    onMouseover(item) {
      item.url = item.gifUrl;
    },
    onMouseout(item) {
      item.url = item.pngUrl;
    },
  },
};
</script>

<style lang="scss" scoped src="./style/index.scss"></style>
<style lang="scss" scoped>
::v-deep .face-main {
  left: -250px !important;
}
</style>
